/**
 * Frontend widget registry — maps a widget `type` string (from dashboard
 * config) to the React component that renders it. Mirrors the backend metric
 * registry: new widget types register once and become usable in any config.
 */
const _widgets = {};

export function registerWidget(type, component) {
  _widgets[type] = component;
}

export function getWidget(type) {
  return _widgets[type] || null;
}

export function hasWidget(type) {
  return Boolean(_widgets[type]);
}

export function registeredTypes() {
  return Object.keys(_widgets);
}
